import React from 'react'
import type { Editor } from '@tiptap/react'
import { SectionOne } from './section/one'
import { SectionTwo } from './section/two'
import { SectionThree } from './section/three'
import { SectionFour } from './section/four'
import { SectionFive } from './section/five'
import { Separator } from '@/components/ui/separator'

const Toolbar = ({ editor }: { editor: Editor }) => (
    <div className="p-2 overflow-x-auto border-b shrink-0 border-border">
      <div className="flex items-center gap-px w-max">
        <SectionOne editor={editor} activeLevels={[1, 2, 3, 4, 5, 6]} />
  
        <Separator orientation="vertical" className="mx-2 h-7" />
  
        <SectionTwo
          editor={editor}
          activeActions={['bold', 'italic', 'underline', 'strikethrough', 'code', 'clearFormatting']}
          mainActionCount={3}
        />
  
        <Separator orientation="vertical" className="mx-2 h-7" />
  
        <SectionThree editor={editor} />
  
        <Separator orientation="vertical" className="mx-2 h-7" />
  
        <SectionFour editor={editor} activeActions={['orderedList', 'bulletList']} mainActionCount={0} />
  
        <Separator orientation="vertical" className="mx-2 h-7" />
  
        <SectionFive editor={editor} activeActions={['codeBlock', 'blockquote', 'horizontalRule']} mainActionCount={0} />
      </div>
    </div>
)
Toolbar.displayName = 'Toolbar'
  
export { Toolbar }